module.exports = __webpack_public_path__ + "img/414.f823ad52.jpg";